export class MealTierItemEntity {   
    id?: number;
    iconUrl?: string | null;
    name?: string | null;
}